module.exports = __webpack_public_path__ + "static/img/animales_28.1de93a2a.jpeg";